/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { ValidatorForm } from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';

import NotificationMetrics from '../../components/Notification/NotificationMetrics';
// import NoficationFilter from '../../components/NotificationFilter.js';
import NotificationGridView from '../../components/Notification/NotificationGridView';
// import { getNotification, readNotification, getNotificationMetricAnalysis, setFilters, getUserBasedActivity } from '../../actions/notificationActions';
import Styles from '../../layouts/Styles.jsx';
import NotificationFilter from '../../components/Notification/NotificationFilter';
import { getNotificationMetrixDetails, getNotificationMetrixContents } from '../../actions/licenseActions';

const Notification = (props) => {
    const { history, classes } = props;
    const dispatch = useDispatch();

    const [isLoading, setLoading] = useState(false);
    const [isLoadingcontent, setisLoadingcontent] = useState(false);
    const [metricAnalysis, setMetricAnalysis] = useState({});
    const [currentnotification, setcurrentnotification] = useState('All');
    const [notification, setnotification] = useState([{}]);
    const [notificationFilters, setNotificationFilters] = useState({
        types: "All",
        filter: "Last 3 Days",
        notification: "All",
        search: ""
    });


    const getNotificationMetrix = useCallback(() => {
        setLoading(true);
        dispatch(getNotificationMetrixDetails()).then((response) => {
            if (response) {
                setMetricAnalysis(response);
            }
            setLoading(false);
        });
    }, [dispatch]);

    const getNotificationMetrixContent = useCallback((filters) => {
        setisLoadingcontent(true)
        const filterList = filters ? filters : {
            types: "All",
            filter: "Last 3 Days",
            notification: "All",
            search: ""
        };
        setNotificationFilters(filterList)
        dispatch(getNotificationMetrixContents({ ...filterList })).then((response) => {
            if (response) {
                setnotification([...response]);
            }
            setLoading(false);
            setisLoadingcontent(false)
        });
    }, [dispatch]);

    const changeFilter = (value) => {
        setcurrentnotification(value);
        const filters = notificationFilters;
        filters.notification = value;
        getNotificationMetrixContent(filters);
    };

    const onChangeFilter = (filters, signal) => {
        setcurrentnotification(filters?.notification || 'All');
        getNotificationMetrixContent(filters);
    };

    useEffect(() => {
        getNotificationMetrix();
        getNotificationMetrixContent({
            types: "All",
            filter: "Last 3 Days",
            notification: "All",
            search: ""
        });
    }, []);


    return (
        <Grid>
            <ValidatorForm name="Notification" onSubmit={() => null}>
                <NotificationFilter
                    onChangeFilterResult={(filters, signal) => onChangeFilter(filters, signal)}
                    history={history}
                    notifications={notification}
                    notificationFilters={notificationFilters}
                />
                <NotificationMetrics
                    isLoading={isLoading}
                    filters={currentnotification}
                    metricAnalysis={metricAnalysis}
                    onChangeFilter={(value) => changeFilter(value)}
                />
                <Grid className={classes.container}>
                    <NotificationGridView
                        currentnotification={currentnotification}
                        // getUserBasedActivity={(userid) => getUserActivity(userid)}
                        isLoadingcontent={isLoadingcontent}
                        // onChangeFilter={(value) => onChangeMetricFilter(value)}
                        isPageLoading={isLoading}
                        notifications={notification}
                    // userAudit={userAudit}
                    // editData={(type, notification) => editData(type, notification)}
                    // onScrollChange={() => onScrollChange()}
                    />
                </Grid>
            </ValidatorForm>
        </Grid>
    );
};

Notification.propTypes = {
    history: PropTypes.object,
    classes: PropTypes.object,
    getPageTitle: PropTypes.func
};

export default withStyles((theme) => ({
    ...Styles(theme)
}))(Notification);